﻿function PopupMenuItem(
  displayText,
  clientRule,
  serverRule,
  appletMoniker,
  serverRuleParameter,
  parentId,
  validates,
  isChecked,
  Enabled
) {
  this.displayText = displayText;
  this.ruleId = serverRule;
  this.parentId = parentId;
  this.qevent = queueEvent;
  this.moniker = appletMoniker;
  this.itemId = serverRuleParameter;
  this.jsFunction = clientRule;
  this.validates = validates;
  this.isChecked = isChecked;
  this.Enabled = Enabled;
}
function PopupRuleMenuItem(
  displayText,
  serverRule,
  parentId,
  appletMoniker,
  serverRuleParameter
) {
  this.displayText = displayText;
  this.ruleId = serverRule;
  this.parentId = parentId;
  this.qevent = queueEvent;
  this.moniker = appletMoniker;
  this.itemId = serverRuleParameter;
}
function PopupJSMenuItem(displayText, jsFunction) {
  this.displayText = displayText;
  this.jsFunction = jsFunction;
}
function PopupSeparatorMenuItem() {}
function positionPopup(popup, refElement, left, top, width, height) {
  var doc = window.GetViewDocument(_currentViewId);
  if (left == undefined) left = 0;
  if (top == undefined) top = 0;
  if (width == undefined) {
    if (refElement) width = $(refElement).outerWidth();
    else width = 0;
  }
  if (height == undefined) {
    if (refElement) height = $(refElement).outerHeight();
    else height = 0;
  }
  var popupLeft;
  var popupTop;
  if (refElement) {
    var refPosition = calcViewPixelPosition(refElement, doc);
    popupLeft = refPosition.X + left;
    popupTop = refPosition.Y + top + height;
  } else {
    popupLeft = left;
    popupTop = top + height;
  }
  var popupWidth = $(popup).outerWidth();
  var popupHeight = $(popup).outerHeight();
  //IE uses document.documentElement, chrome and FF use document.body
  var scrollTop =
    document.documentElement.scrollTop == 0
      ? document.body.scrollTop
      : document.documentElement.scrollTop;
  var scrollLeft =
    document.documentElement.scrollLeft == 0
      ? document.body.scrollLeft
      : document.documentElement.scrollLeft;
  // if it goes off the bottom, pop above instead.
  if ($(doc).height() + scrollTop < popupTop + popupHeight)
    popupTop -= height + popupHeight;
  // prevent from going off-screen:
  popupLeft = Math.min(
    popupLeft,
    $(doc).width() + scrollLeft - popupWidth - 16
  );
  popupLeft = Math.max(popupLeft, scrollLeft);
  popupTop = Math.min(popupTop, $(doc).height() + scrollTop - popupHeight - 16);
  popupTop = Math.max(popupTop, scrollTop);
  popup.style.top = popupTop;
  popup.style.left = popupLeft;
}
// Opens a popup menu with the given choices.
// options.items is an array of PopupRuleMenuItem, PopupJSMenuItem, or PopupSeparatorMenuItem
// The following options are supported:
// items,
// parentControl,
// sourceEvent,
// topPos,
// width,
// height,
// closedCallback,
// containingDocument,
// $jquery
// vid
function openPopupMenu(options) {
  if (!options.$jquery) {
    options.$jquery = $;
  }
  if (!options.vid) {
    options.vid = _currentViewId;
  }
  var targetButton = options.$jquery(options.parentControl);
  // If the menu is currently displayed then close it.
  if (options.$jquery("body").find("#popupcontextmenu").length > 0) {
    var $existingPopupMenu = targetButton.data("popupmenu");
    if ($existingPopupMenu && $existingPopupMenu.close) {
      $existingPopupMenu.close();
      return false;
    }
  }
  //remove existing context before the creating new one
  options
    .$jquery("body")
    .find("#popupcontextmenu")
    .remove();
  options
    .$jquery("body")
    .find("#inforMenu_iframe")
    .remove();
  if (options.width == undefined)
    options.width = options.$jquery(options.parentControl).outerWidth();
  if (options.height == undefined)
    options.height = options.$jquery(options.parentControl).outerHeight();
  var popupMenu = null;
  var popup = null;

  // Build a list of controls
  var controls = [];
  $(".selected").each(function(i, e) {
    var control = $(this).attr("controlid");

    if (control != undefined)
      controls.push(control);
  });

  // Disable delete button when only an out-of-the-box control is selected
  // Enable delete button for the following scenarios:
  // 1. When selected control is an agency-added control only
  // 2. When selected controls are agency-added and out-of-the-box controls
  var disableDeleteBtn = false;
  for (var i = 0; i < controls.length; i++) {
    if (this.propertiesLookup[controls[i]] != undefined) {
      var isHansenControl = this.propertiesLookup[controls[i]].getAttribute("isHansenControl");

      if (isHansenControl != undefined)
        disableDeleteBtn = isHansenControl.toLowerCase() == "true" ? true : false;
      else
        disableDeleteBtn = false;

      if (!disableDeleteBtn)
        break;
    }
  }

  if (options.items.length > 0) {
    var popDoc = window.GetViewDocument(options.vid);
    var $popup = options.$jquery(
      '<ul id="popupcontextmenu" class="popupmenu">'
    );
    var seperator = false;
    for (var i = 0; i < options.items.length; i++) {
      var item = options.items[i];
      if (item instanceof PopupSeparatorMenuItem) {
        seperator = true;
      } else {
          var itemHTML = '<a href="#item_' + i + '">';
          if (item.Enabled == false) {
              itemHTML = '<a href="#item_' + i + '"class="disabled">';
          }
        if (item.isChecked != null) {
          itemHTML +=
            '<input type="checkbox" ' +
            (item.isChecked ? "checked" : "") +
            ' class="inforCheckbox"/>' +
            '<label class="inforCheckboxLabel">' +
            item.displayText +
            "</label>";
        } else {
          itemHTML += item.displayText;
        }
        itemHTML += "</a>";
        var $li = options.$jquery(
          '<li id="item_' + i + '">' + itemHTML + "</li>"
        );
        if (item.isChecked != null) {
          $li.addClass("checkbox");
        }
        if (seperator) $li.addClass("popupmenu-seperator");
        if ((item.disabled) ||
            (disableDeleteBtn &&
              (item.displayText == "Delete" && item.parentId == "btnEditMenu"))) {
          $li.addClass("is-disabled");
        }
        $li.appendTo($popup);
      }
    }
    if (options.containingDocument) {
      options.$jquery(options.containingDocument.body).append($popup);
    } else {
      options.$jquery("body").append($popup);
    }
    var offsetLeft = -2;
    if (options.sourceEvent && options.sourceEvent.setOffsetLeft) {
      offsetLeft = options.sourceEvent.offsetX;
    }
    targetButton.attr("data-toggle", "popupmenu");
    targetButton.off("selected");
    targetButton.off("close");
    targetButton
      .popupmenu({
        trigger: "immediate",
        menu: "popupcontextmenu"
      })
      .on("close", function(e, menu) {
        if (options.closedCallback) options.closedCallback();
        options
          .$jquery("body")
          .find("#popupcontextmenu")
          .remove();
        var iFrameToRemove = targetButton.data("popupMenuIframe");
        if (iFrameToRemove.length > 0) {
          iFrameToRemove.remove();
        }
        targetButton.removeAttr("data-toggle");
        return false;
      })
      .on("selected", function(e, el) {
        var index = parseInt(el.attr("href").split("_")[1]);
        var item = options.items[index];
        var ret = true;
        var td = item;
        var view = options.view;
        if (!view) {
          view = window;
        }
        var postPopupMenuValidationProcessing = function(validationSuccessful) {
          ret = validationSuccessful;
          if (ret && td.jsFunction) {
            if (typeof td.jsFunction == "function") ret = td.jsFunction(td);
            else ret = view.eval(td.jsFunction);
          }
          if (
            (ret == undefined || ret == null || ret) &&
            td.ruleId &&
            td.ruleId.length > 0
          ) {
            var args = "";
            if (td.itemId && td.itemId.length > 0)
              args =
                '<PARAM name="itemId" val="' + xmlEscape(td.itemId) + '"/>';
            //HPS-68354: Passing the parentId instead of itemId to get the appropriate applet name associated with it.
            if (td.moniker)
              view.queueEvent(
                td.ruleId,
                td.parentId,
                td.moniker,
                args,
                undefined,
                options.vid
              );
            else
              view.queueEvent(
                td.ruleId,
                td.parentId,
                undefined,
                args,
                undefined,
                options.vid
              );
          }
          if (typeof ret == "function") ret();
          if (options.closedCallback) options.closedCallback();
        };
        if (ret && td.validates) {
          ret = view.Validate(
            undefined,
            this.id,
            postPopupMenuValidationProcessing
          );
        } else {
          postPopupMenuValidationProcessing.call(this, true);
        }
        return false;
      })
      .on("destroy.popupmenu", function(e, menu) {
        if (options.closedCallback) options.closedCallback();
        var iFrameToRemove = targetButton.data("popupMenuIframe");
        if (iFrameToRemove.length > 0) {
          iFrameToRemove.remove();
        }
        targetButton.removeAttr("data-toggle");
        return false;
      });
    var $popContainer = options.$jquery(".popupmenu.is-open"); //if there are multiple, we want to last one we just created
    if ($popContainer.length > 0) {
      //Set the width on the popup menu so the container border will display when off the page.
      $popContainer.width($popup.width() + 8);
      // prevent popup from rendering off-screen
      var isPopupOffScreen =
        options.$jquery("body").width() <
        $popContainer.width() + $popContainer.offset().left;
      if (isPopupOffScreen) {
        $popContainer.offset({
          left: options.$jquery("body").width() - $popContainer.width() - 8
        });
      }
      var owner = options.parentControl.ownerDocument;
      if (!owner && options.parentControl.length) {
        owner = options.parentControl[0].ownerDocument;
      }
      // if these are NOT the same then that means the options.parentControl is in the navbar so adjust the options.height
      if (owner && !(instance.isModalDiv || options.isModalDiv)) {
        if (!options.containingDocument && popDoc != owner) {
          $popContainer.css(
            "top",
            $(popDoc).scrollTop() + (options.topPos ? options.topPos : 2)
          );
        }
      }
      // this puts an iframe behind the context menu to ensure that it always shows up no matter what is behind the menu.
      // you can see this issue in My Infor when you have an Outlook dashboard, the ActiveX is always on top and the menu shows up
      // behind it.  The iframe is able to be positioned on top of the ActiveX control therefore the menu will now be on top of the iframe
      // and it will correctly show in the foreground
      $offset = $popContainer.offset();
      var $iframe = options.$jquery(
        '<iframe id="inforMenu_iframe" style="position:absolute;z-index:1000" src="about:blank" scrolling="no" frameborder="0" />'
      );
      $iframe.offset({ top: $offset.top, left: $offset.left });
      var outerHeight = $popContainer.outerHeight(true);
      var outerWidth = $popContainer.outerWidth(true);
      $iframe.css({ width: outerWidth, height: outerHeight });
      //if we specify a left position, move the popup parent and iframe
      if (options.left && options.left > 0) {
        //find the correct left so it doesn't run off the page.
        var left = options.left;
        if (left + outerWidth + 10 > options.$jquery("body").width()) {
          //using a 10 px buffer from end of page
          left = options.$jquery("body").width() - outerWidth - 10;
        }
        $popContainer.parent().css({ left: left });
        $iframe.css({ left: left });
      }
      targetButton.data("popupMenuIframe", $iframe);
      options.$jquery("body").append($iframe);
    }
  }
  return popup;
}
